import { http } from "@/http/axios.js";

// 机构资方 - 列表（不分页，返回完整机构资方数组）
export function getCapitalOrgList() {
  return http({
    url: "/admin/capitalOrg/list",
    method: "get",
  });
}

// 机构资方 - 详情
export function getCapitalOrgDetail(params) {
  return http({
    url: "/admin/capitalOrg/detail",
    method: "get",
    params,
  });
}

// 机构资方 - 编辑基础信息
export function editCapitalOrg(data) {
  return http({
    url: "/admin/capitalOrg/edit",
    method: "post",
    data,
  });
}

// 机构资方 - 推单状态编辑
export function editPushOrderStatus(data) {
  return http({
    url: "/admin/capitalOrg/pushOrderStatus/edit",
    method: "post",
    data,
  });
}

// 机构资方 - 关联方案编辑
export function editSupportCombo(data) {
  return http({
    url: "/admin/capitalOrg/supportCombo/edit",
    method: "post",
    data,
  });
}

// 方案分页（按本期决策：在本 api.js 中复制一份 src/views/store/combo/api.js 已有的 getComboList，
// 避免 combo-multi-picker 组件与 store/combo 模块耦合；接口路径保持一致）
export function getComboListForOrg(params) {
  return http({
    url: "/admin/store/combo/page",
    method: "get",
    params,
  });
}
